import { options } from "./base";

export const common = {
  namespaced: true,
  modules: {
    makers: {
      namespaced: true,
      modules: {
        options: options("makers")
      }
    },
    products: {
      namespaced: true,
      modules: {
        options: options("products")
      }
    },
    keywords: {
      namespaced: true,
      modules: {
        options: options("keywords")
      }
    },
    recipe_categories: {
      namespaced: true,
      modules: {
        options: options("recipe_categories")
      }
    },
    product_large_categories: {
      namespaced: true,
      modules: {
        options: options("product_large_categories")
      }
    },
    product_medium_categories: {
      namespaced: true,
      modules: {
        options: options("product_medium_categories")
      }
    },
    review_sets: {
      namespaced: true,
      modules: {
        options: options("review_sets")
      }
    },
    review_items: {
      namespaced: true,
      modules: {
        options: options("review_items")
      }
    },
    request_status: {
      namespaced: true,
      modules: {
        options: options("request_status")
      }
    },
    plans: {
      namespaced: true,
      modules: {
        options: options("plans")
      }
    },
    publish: {
      namespaced: true,
      modules: {
        options: options("publish")
      }
    },
    delete_status: {
      namespaced: true,
      modules: {
        options: options("delete_status")
      }
    },
    user_types: {
      namespaced: true,
      modules: {
        options: options("user_types")
      }
    },
    genders: {
      namespaced: true,
      modules: {
        options: options("genders")
      }
    },
    large_locations: {
      namespaced: true,
      modules: {
        options: options("large_locations")
      }
    },
    medium_locations: {
      namespaced: true,
      modules: {
        options: options("medium_locations")
      }
    },
    biz_large_categories: {
      namespaced: true,
      modules: {
        options: options("biz_large_categories")
      }
    },
    biz_medium_categories: {
      namespaced: true,
      modules: {
        options: options("biz_medium_categories")
      }
    },
    business_scales: {
      namespaced: true,
      modules: {
        options: options("business_scales")
      }
    },
    business_areas: {
      namespaced: true,
      modules: {
        options: options("business_areas")
      }
    },
    genres: {
      namespaced: true,
      modules: {
        options: options("genres")
      }
    },
    avarage_spendings: {
      namespaced: true,
      modules: {
        options: options("avarage_spendings")
      }
    },
    lunch_menus: {
      namespaced: true,
      modules: {
        options: options("lunch_menus")
      }
    },
    plan_nums: {
      namespaced: true,
      modules: {
        options: options("plan_nums")
      }
    },
    inquiry_status: {
      namespaced: true,
      modules: {
        options: options("inquiry_status")
      }
    },
    inquirer_types: {
      namespaced: true,
      modules: {
        options: options("inquirer_types")
      }
    },
    permissions: {
      namespaced: true,
      modules: {
        options: options("permissions")
      }
    },
    other_permissions: {
      namespaced: true,
      modules: {
        options: options("other_permissions")
      }
    },
    for_paid_users: {
      namespaced: true,
      modules: {
        options: options("for_paid_users")
      }
    },
    master_status: {
      namespaced: true,
      modules: {
        options: options("master_status")
      }
    },
    provider_administrators: {
      namespaced: true,
      modules: {
        options: options("provider_administrators")
      }
    },
    questionnaires: {
      namespaced: true,
      modules: {
        options: options("questionnaires")
      }
    },
    reminder_types: {
      namespaced: true,
      modules: {
        options: options("reminder_types")
      }
    },
    reminder_templates: {
      namespaced: true,
      modules: {
        options: options("reminder_templates")
      }
    },
    sample_paid: {
      namespaced: true,
      modules: {
        options: options("sample_paid")
      }
    }
  }
};
